import React from 'react'
import { withPrefix } from 'gatsby'
import { IcoPointingFinger } from '../../../../lib/svg'
import './como-hacer-uso-del-programa.css'

const ComoHacerUsoDelPrograma = ({
  scrollToSection,
  AhorroYaStepBtn,
  redirectAhorroYa,
}) => {
  const stepsInfo = [
    {
      stepNumber: 'Paso 1',
      title: 'Regístrate al programa',
      description:
        'Completa el formulario con tus datos ¡Te tomará menos de 1 minuto!',
      image: {
        src: '/images/prima-productos/ahorroYa-step-1.svg',
        alt: 'ahorroYa-step-1',
      },
      button: (
        <button
          className="ahorroYa__button ahorroYa__button--white"
          onClick={() => {
            AhorroYaStepBtn('¡Afíliate ahora!')
            scrollToSection('ahorroYa-register-section')
          }}
        >
          <div className="items-center inline-flex">
            <span className="pr-3 pl-2 c-gray--4">¡Afíliate ahora!</span>
            {<IcoPointingFinger />}
          </div>
        </button>
      ),
    },
    {
      stepNumber: 'Paso 2',
      title: 'Identifícate y consume',
      description:
        'En los establecimientos de nuestros aliados, identifícate como usuario de AhorroYa!',
      image: {
        src: '/images/prima-productos/ahorroYa-step-3.svg',
        alt: 'ahorroYa-step-3',
      },
      button: <></>,
    },
    {
      stepNumber: 'Paso 3',
      title: '¡Ahorra ya!',
      description:
        'Tu dinero será transferido a tu cuenta de aportes voluntarios de libre disponibilidad*',
      image: {
        src: '/images/prima-productos/ahorroYa-step-4.svg',
        alt: 'ahorroYa-step-4',
      },
      button: <></>,
    },
  ]

  return (
    <div className="ahorroYa__section-container ahorroYa__container-steps">
      <h2 className="ahorroYa-section__title">
        Un porcentaje de tus consumos se va a tu cuenta de aportes voluntarios*
        en Prima AFP
      </h2>
      <h3 className="ahorroYa-section__title ahorroYa-section__title--subtitle">
        ¿Cómo hacer uso del programa?
      </h3>

      <div className="ahorroYa-how-to-use__steps-rod"></div>

      <div className="ahorroYa-how-to-use__steps-container">
        {stepsInfo.map(step => (
          <div className="ahorroYa-how-to-use__steps-container_step">
            <div className="ahorroYa-how-to-use__circle-container">
              <h3 className="ahorroYa-how-to-use__circle__step">
                {step.stepNumber}
              </h3>
              <div className="ahorroYa-how-to-use__circle__group">
                <div className="ahorroYa-how-to-use__circle">
                  <div className="ahorroYa-how-to-use__inner-circle"></div>
                </div>
                <div className="ahorroYa-how-to-use__tiny-circle ahorroYa-how-to-use__tiny-circle-one"></div>
                <div className="ahorroYa-how-to-use__tiny-circle ahorroYa-how-to-use__tiny-circle-two"></div>
              </div>
            </div>
            <div className="ahorroYa-how-to-use__content-without-circle">
              <img
                className="ahorroYa-how-to-use__image-steps"
                src={withPrefix(step.image.src)}
                alt={step.image.alt}
                height={211}
              />
              <div className="ahorroYa-how-to-use__steps-container_step_content">
                <h2>{step.title}</h2>
                <p>{step.description}</p>
              </div>
              <>{step.button}</>
            </div>
          </div>
        ))}
      </div>

      <div className="ahorroYa-how-to-use__footer">
        <p>
          *La cuenta de Aportes Voluntarios Sin fin Previsional (Cuentas Metas)
          está afecta a una comisión mensual sobre el saldo administrado: Fondo
          1: 0.10%, Fondo 2: 0.12% y Fondo 3: 0.16%.
        </p>

        <p>
          <strong>
            **Podrás utilizar el beneficio pasado las 72 horas después de
            registrarte.
          </strong>
        </p>
        <p>
          La cuenta de Aportes Voluntarios Sin fin Previsional está sujeta al
          cobro del impuesto a la renta en caso la rentabilidad sea positiva.
        </p>
      </div>
    </div>
  )
}

export default ComoHacerUsoDelPrograma
